import { Breadcrumb } from 'react-bootstrap';
import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import AnswerModal from "./AnswerModal";
import { useQuiz } from "../QuizContext";
import '../App.css';

/*사무실*/
function Ending() {
  const [highlight, setHighlight] = useState(true);
  const { setTabletSolved } = useQuiz();
  const [showModal, setShowModal] = useState(false);
  const [elapsedMinutes, setElapsedMinutes] = useState(0); // ✅ 상태 추가

  useEffect(() => {
    setTabletSolved(false);

    const startTime = parseInt(localStorage.getItem('startTime'), 10);
    const endTime = new Date().getTime();
    const minutes = Math.floor((endTime - startTime) / 60000);
    setElapsedMinutes(minutes); 
  }, []);

  return (
    <div className="container mt-4 position-relative" style={{ height: '100vh' }}>
      {/* Breadcrumb */}
      <div className="d-flex justify-content-between align-items-center">
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={(e) => {
            e.preventDefault();  // 링크 기본동작 막기
            if (elapsedMinutes > 60){
              alert(`이제 퇴근할 수 있다. ${elapsedMinutes}분만에... 후......`);
            } else if (elapsedMinutes > 30) {
              alert(`이제 퇴근할 수 있다. ${elapsedMinutes}분만에... 후...`);
            } else {
              alert(`이제 퇴근할 수 있다. ${elapsedMinutes}분만에...`);
            }
          }}
          href="#" // href 있어야 커서 포인터 모양 유지됨
          style={{ cursor: 'pointer' }} // 클릭 가능하다는 시각적 표시
        >
          집
        </Breadcrumb.Item>
        <Breadcrumb.Item active>사무실</Breadcrumb.Item>
      </Breadcrumb>
      {/* 오른쪽 상단 버튼 */}
        <Button
        onClick={() => {
          setShowModal(true);
          setHighlight(false);
        }}
        variant="primary"
        size="sm"
        className={highlight ? "highlight-btn" : ""}
        style={{
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          padding: '0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop:'-12px'
        }}
      >
<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor"
    className="bi bi-check-circle" viewBox="0 0 16 16">
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
    <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094
      a.75.75 0 0 0-1.06 1.06L6.97 11.03
      a.75.75 0 0 0 1.079-.02l3.992-4.99
      a.75.75 0 0 0-1.071-1.05"/>
  </svg>
        </Button>
      <AnswerModal show={showModal} handleClose={() => setShowModal(false)} />
      </div>

      {/* 수평선 */}
      <hr className="border border-dark-subtle border-2 opacity-100" />

      {/* 설명 */}
      <div className="text-start justify-content-center align-content-center">
        <p>사무실로 복귀하자 옆자리 동료가 길드장님의 안부를 묻는다</p>
        <p>평소와 똑같았다고 하자 동료는 얼른 길드장님이 돌아오셨으면 좋겠다고 말한다. 길드의 수익률이 점점 바닥을 친다면서</p>
        <p>하지만 길드장님이 돌아온다고 해도 뭘 하실 수 있겠는가? </p>
        <p>몬스터도 던전도 없는 이 평화로운 세상에서……</p>
        <p
        style={{
            position: 'absolute',
            bottom: '40vh',      // 원하는 여백만큼 조절
            right: '10vw',       // 원하는 여백만큼 조절
            fontStyle: 'italic',
            margin: 0
        }}
        >
        Fin</p>
      </div>
    </div>

  );
}

export default Ending;